module.exports = __webpack_public_path__ + "img/clock-icon.3f77e8cd.png";